const route = () => `/orders`;

export default route;
